import AttrOverlay from './src/main'
import { addComponent } from '~/utils/helper'

export default addComponent(AttrOverlay)


// WEBPACK FOOTER //
// ./public/attr-overlay/index.js